(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["games-list-search"] && !Shopify.designMode) return;
  try {
    
  const GAMES_LIST_FAVORITES = [
    { n: 'Super Mario Bros.', a: true },
    { n: 'Pokemon Blue', a: true },
    { n: 'The Legend of Zelda', a: true },
    { n: 'Sonic The Hedgehog', a: true },
    { n: 'Grand Theft Auto', a: true },
    { n: 'Crash Bandicoot', a: false },
    { n: 'Tekken 3', a: true },
    { n: 'Final Fantasy VII', a: true },
    { n: 'Street Fighter II', a: true },
    { n: 'Metal Gear Solid', a: true },
    { n: 'Resident Evil', a: true },
    { n: "Tony Hawk's Pro Skater", a: true },
    { n: 'Metal Slug', a: true },
    { n: 'Mortal Kombat', a: true },
    { n: 'Castlevania', a: true }
  ];

  function gamesListNormalize(str) {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/['\u2019]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function gamesListEscapeHtml(str) {
    return str.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  class GamesListSearch extends HTMLElement {
    constructor() {
      super();
      this.data = null;
      this.filtered = [];
      this.shown = 0;
      this.pageSize = parseInt(this.dataset.pageSize, 10) || 50;
    }

    connectedCallback() {
      this.input = this.querySelector('.games-list-search__input');
      this.clearButton = this.querySelector('.games-list-search__clear');
      this.resultsEl = this.querySelector('.games-list-search__results');
      this.tbody = this.querySelector('tbody');
      this.countEl = this.querySelector('.games-list-search__count');
      this.emptyEl = this.querySelector('.games-list-search__empty');
      this.viewMoreButton = this.querySelector('.games-list-search__view-more');
      this.checkmarkTemplate = null;

      this.input.addEventListener('input', this.onInput.bind(this));
      this.clearButton.addEventListener('click', this.onClear.bind(this));
      this.viewMoreButton.addEventListener('click', this.onViewMore.bind(this));
    }

    async ensureData() {
      if (this.data) return this.data;
      const response = await fetch(this.dataset.url);
      this.data = await response.json();
      return this.data;
    }

    onInput() {
      clearTimeout(this.debounceTimer);
      const value = this.input.value.trim();
      this.clearButton.hidden = value.length === 0;
      this.debounceTimer = setTimeout(() => this.runSearch(value), 200);
    }

    onClear() {
      this.input.value = '';
      this.clearButton.hidden = true;
      this.runSearch('');
      this.input.focus();
    }

    async runSearch(query) {
      if (query.length === 0) {
        this.resultsEl.hidden = true;
        this.tbody.innerHTML = '';
        return;
      }

      const data = await this.ensureData();
      const needle = gamesListNormalize(query);

      if (needle.length === 0) {
        this.resultsEl.hidden = true;
        this.tbody.innerHTML = '';
        return;
      }

      const words = needle.split(' ');

      this.filtered = data
        .filter((game) => {
          if (game._s === undefined) game._s = gamesListNormalize(game.n);
          return words.every((word) => game._s.indexOf(word) !== -1);
        })
        .sort((x, y) => {
          const xs = x._s.startsWith(needle) ? 0 : 1;
          const ys = y._s.startsWith(needle) ? 0 : 1;
          if (xs !== ys) return xs - ys;
          if (x._s.length !== y._s.length) return x._s.length - y._s.length;
          return x.n.localeCompare(y.n);
        });

      this.lastQuery = query;
      this.shown = 0;
      this.resultsEl.hidden = false;
      this.tbody.innerHTML = '';
      this.renderNextPage();
    }

    renderNextPage() {
      if (this.filtered.length === 0) {
        this.showNoResults(this.lastQuery);
        return;
      }

      const nextBatch = this.filtered.slice(this.shown, this.shown + this.pageSize);
      const fragment = document.createDocumentFragment();
      nextBatch.forEach((game) => {
        const row = document.createElement('tr');

        const titleCell = document.createElement('td');
        titleCell.textContent = game.n;
        row.appendChild(titleCell);

        row.appendChild(this.buildCheckCell(game.a));
        row.appendChild(this.buildCheckCell(game.b));

        fragment.appendChild(row);
      });
      this.tbody.appendChild(fragment);
      this.shown += nextBatch.length;

      this.emptyEl.hidden = true;
      this.countEl.textContent = `${this.filtered.length} result${this.filtered.length === 1 ? '' : 's'}`;
      this.viewMoreButton.hidden = this.shown >= this.filtered.length;
    }

    showNoResults(query) {
      this.countEl.textContent = '';
      this.viewMoreButton.hidden = true;
      this.emptyEl.hidden = false;
      this.emptyEl.innerHTML =
        '<p>No exact match for "<strong>' + gamesListEscapeHtml(query) + '</strong>" — but it\'s very likely on the console, just not the list yet.</p>' +
        '<p>We\'re always adding games and can\'t list them all. Not on here? Email us at <a href="mailto:help@thetekko.com">help@thetekko.com</a> and we\'ll add it once you\'re set up.</p>' +
        '<p>In the meantime, some favorites:</p>';

      const fragment = document.createDocumentFragment();
      GAMES_LIST_FAVORITES.forEach((game) => {
        const row = document.createElement('tr');

        const titleCell = document.createElement('td');
        titleCell.textContent = game.n;
        row.appendChild(titleCell);

        row.appendChild(this.buildCheckCell(game.a));
        row.appendChild(this.buildCheckCell(true));

        fragment.appendChild(row);
      });
      this.tbody.appendChild(fragment);
    }

    buildCheckCell(hasIt) {
      const cell = document.createElement('td');
      cell.className = 'games-list-search__col-check';
      if (hasIt) {
        cell.innerHTML = this.checkmarkMarkup();
      }
      return cell;
    }

    checkmarkMarkup() {
      if (!this._checkmarkMarkup) {
        const existing = this.querySelector('.games-list-search__checkmark-source');
        this._checkmarkMarkup = existing
          ? existing.innerHTML
          : '<svg class="icon icon-checkmark" viewBox="0 0 12 9" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"/></svg>';
      }
      return this._checkmarkMarkup;
    }

    onViewMore() {
      this.renderNextPage();
    }
  }

  customElements.define('games-list-search', GamesListSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
